import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LongPressManagerService {

  private longPressTimer: any;

  private isLongPress: boolean = false;
  private longPressDuration: number = 500;


  /**
   * Configurar la duración de retención
   *
   */
  setLongPressDuration(duration: number) {
    this.longPressDuration = duration;
  }


  /**
   * Manejar el inicio del toque (touchstart)
   *
   */
  onTouchStart(event: any, onLongPress: () => void) {
    this.isLongPress = false;

    this.longPressTimer = setTimeout(() => {
      this.isLongPress = true;

      onLongPress();
      event.preventDefault?.();
      event.stopPropagation?.();
    }, this.longPressDuration);
  }


  /**
   * Manejar el fin del toque (touchend)
   *
   */
  onTouchEnd() {

    if (!this.longPressTimer) {
      return;
    }

    clearTimeout(this.longPressTimer);
    this.longPressTimer = null;
  }


  /**
   * Manejar el click y decidir si ejecutar la acción normal o no
   *
   */
  onClick(event: any, onNormalClick?: () => void): boolean {

    if (this.isLongPress) {
      this.isLongPress = false;

      event.preventDefault?.();
      event.stopPropagation?.();

      return true;
    }

    if (onNormalClick) {
      onNormalClick();
    }

    return false;
  }


  /**
   * Resetear el estado de retención
   *
   */
  reset() {

    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }

    this.isLongPress = false;
  }


  /**
   * Destruir el servicio y limpiar recursos
   *
   */
  destroy() {
    this.reset();
  }

}
